import React, { createContext, useContext, useState, useEffect } from 'react';
import useAxiosWithAuth from '../hooks/useAxiosWithAuth';

// إنشاء سياق المحفظة
const WalletContext = createContext();

// مزود سياق المحفظة
export const WalletProvider = ({ children }) => {
  const axiosAuth = useAxiosWithAuth();
  
  // حالة بيانات المحفظة
  const [wallet, setWallet] = useState(null);
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  
  // جلب بيانات المحفظة
  const fetchWalletBalance = async () => {
    setLoading(true);
    setError(null);
    
    try {
      const response = await axiosAuth.get('/api/wallet/balance');
      setWallet(response.data);
      return response.data;
    } catch (err) {
      console.error('Error fetching wallet balance:', err);
      setError('حدث خطأ أثناء جلب بيانات المحفظة');
      return null;
    } finally {
      setLoading(false);
    }
  };
  
  // جلب المعاملات
  const fetchTransactions = async () => {
    setLoading(true);
    setError(null);
    
    try {
      const response = await axiosAuth.get('/api/wallet/transactions');
      setTransactions(response.data || []);
      return response.data;
    } catch (err) {
      console.error('Error fetching transactions:', err);
      setError('حدث خطأ أثناء جلب المعاملات');
      return [];
    } finally {
      setLoading(false);
    }
  };
  
  // تحديث بيانات المحفظة
  const refreshWalletData = async () => {
    await Promise.all([
      fetchWalletBalance(),
      fetchTransactions()
    ]);
  };
  
  // جلب البيانات عند تحميل المكون
  useEffect(() => {
    fetchWalletBalance();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  
  // القيمة التي سيتم توفيرها للمكونات الفرعية
  const value = {
    wallet,
    transactions,
    loading,
    error,
    fetchWalletBalance,
    fetchTransactions,
    refreshWalletData
  };
  
  return (
    <WalletContext.Provider value={value}>
      {children}
    </WalletContext.Provider>
  );
};

// هوك مخصص لاستخدام سياق المحفظة
export const useWallet = () => {
  const context = useContext(WalletContext);
  
  if (!context) {
    throw new Error('يجب استخدام useWallet داخل WalletProvider');
  }
  
  return context;
};